import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import classNames from 'classnames'
import { Storage } from 'aws-amplify'
import { S3Image } from 'aws-amplify-react'
import './ImageViewer.css'

import defaultImageMale from './BT_pro_male.jpg'
import defaultImageFemale from './BT_pro_female.jpg'

const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="69" height="52">
<path fill="#57A50B" fill-rule="nonzero" d="M4.6 0C2.065 0 0 2.06 0 4.588v35.177c0 2.528 2.065 4.588 4.6 4.588h42.07C48.252 48.807 52.5 52 57.5 52 63.842 52 69 46.855 69 40.53c0-4.988-3.202-9.226-7.667-10.802V4.588c0-2.528-2.065-4.588-4.6-4.588H4.6zm0 1.53h52.133A3.04 3.04 0 0 1 59.8 4.587v24.71a11.62 11.62 0 0 0-2.3-.24c-.17 0-.335.018-.503.025l-9.488-7.504a.792.792 0 0 0-.958 0l-11.212 9.463-14.064-15.51c-.433-.364-.782-.293-1.078-.046L1.533 31.95V4.588A3.04 3.04 0 0 1 4.6 1.53zm32.2 7.646c-2.531 0-4.6 2.064-4.6 4.589 0 2.525 2.069 4.588 4.6 4.588 2.531 0 4.6-2.063 4.6-4.588s-2.069-4.589-4.6-4.589zm0 1.53a3.051 3.051 0 0 1 3.067 3.059 3.051 3.051 0 0 1-3.067 3.059 3.051 3.051 0 0 1-3.067-3.06 3.051 3.051 0 0 1 3.067-3.058zm-16.148 6.428l14.04 15.485c.264.3.776.333 1.078.072l11.284-9.535 7.835 6.214C49.798 30.55 46 35.097 46 40.53c0 .782.09 1.554.24 2.294H4.6a3.04 3.04 0 0 1-3.067-3.06v-5.782l19.12-16.848zM57.5 30.588c5.514 0 9.967 4.442 9.967 9.941 0 5.5-4.453 9.942-9.967 9.942s-9.967-4.442-9.967-9.942c0-5.499 4.453-9.94 9.967-9.94zm0 3.824a.766.766 0 0 0-.767.764v4.589h-4.6a.766.766 0 1 0 0 1.53h4.6v4.587a.766.766 0 0 0 1.534 0v-4.588h4.6a.766.766 0 1 0 0-1.53h-4.6v-4.588a.766.766 0 0 0-.767-.764z"/>
</svg>`;

const ImageDropzone = ({onDrop, uploading, fileKey}) => {
    return (
        <div className="imageviewer--dropzone-wrap">
            <label className="label" htmlFor="profileimage">
                    Upload profile image
                </label><br />
                { !fileKey && (
                    <Dropzone
                        onDrop={ onDrop }
                        disablePreview={true}
                        accept="image/png, image/jpg, image/jpeg"
                        name="profileimage"
                        className={classNames('imageviewer--dropzone', {'imageviewer--dropzone__uploading': uploading})}
                    >
                    <p>
                        <span className="imageviewer--dropzone-icon" dangerouslySetInnerHTML={{__html: icon}} /><br />
                        Drop image or <span className="anchorlike">browse your files</span>
                    </p>
                    </Dropzone>
                )}
                { fileKey && <S3Image path={ fileKey } /> }
        </div>
    )
}

class ImageViewer extends Component {

    state = {
        uploading: false,
        uploadError: false
    }

    onImageUploaded = async ({key}) => {
        const { onChange } = this.props
        await this.setStateAsync({...this.state, uploading: false, uploadError: false})
        onChange(key)
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        })
    }

    uploadImage = async (acceptedFiles, rejectedFiles) => {
        const { prepend, id } = this.props
        
        if(acceptedFiles && acceptedFiles.length){
            
            const file = acceptedFiles[0]
            const name = `${prepend}_${id}_${file.name}`

            await this.setStateAsync({...this.state, uploading: true, uploadError: false})
            
            try{
                const fileKey = await Storage.put(name, file)
                await this.onImageUploaded(fileKey)
            }
            catch(error){
                console.log(error)
                await this.setStateAsync({...this.state, uploading: false, uploadError: true})
            }
        }
      }
    
    render() {
        const { uploading } = this.state
        const { fileKey = undefined, gender = undefined, defaultImage, setDefaultImage } = this.props
        const defaultImagePath = gender === 'Male' ? defaultImageMale : defaultImageFemale

        return (
            <div className="imageviewer">
                { defaultImage ? <img alt="Default" className="imageviewer--defaultimage" src={defaultImagePath} /> : <ImageDropzone onDrop={ this.uploadImage } uploading={uploading} fileKey={fileKey} /> }
                { gender && <label htmlFor="defaultImage" className="imageviewer--setdefaultimage"><input onChange={setDefaultImage} checked={defaultImage} name="defaultImage" id="defaultImage" type="checkbox" /> Use default image</label> }
            </div>
        )
    }
}

export default ImageViewer



// WEBPACK FOOTER //
// ./src/components/ImageViewer/ImageViewer.js